webpackJsonp([172411548396689],{

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(27);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Elements = function Elements(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'idealkraft - Impressum'
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: 'Impressum (Anbieterkennzeichnung)' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { id: 'main', className: 'alt' },
	      _react2.default.createElement(
	        'section',
	        { id: 'one' },
	        _react2.default.createElement(
	          'div',
	          { className: 'inner' },
	          _react2.default.createElement(
	            'header',
	            { className: 'major' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Impressum'
	            )
	          ),
	          _react2.default.createElement(
	            'section',
	            null,
	            _react2.default.createElement(
	              'h2',
	              null,
	              'Angaben gem\xE4\xDF \xA7 5 TMG'
	            ),
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Verantwortlich f\xFCr den Inhalt nach \xA7 55 Abs. 2 RStV: Thomas Fr\xFCtel'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'contact-method' },
	              _react2.default.createElement('span', { className: 'icon alt fa-home' }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Anschrift'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                'Bergwerksstra\xDFe 1a',
	                _react2.default.createElement('br', null),
	                '47239 Duisburg',
	                _react2.default.createElement('br', null),
	                'Deutschland'
	              ),
	              _react2.default.createElement('span', { className: 'icon alt fa-envelope' }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Email'
	              ),
	              'idealkraft@fruetel.de'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Elements;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-impressum-js-ce72251fbf0378fb8115.js